import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as GoogleAnalytics from 'react-ga';

import quotingActions from '../quoting/quotingActions';
import userActions from '../user/userActions';

import Button from '../components/buttons/Button';
import { BirthDatePicker, DropdownInput, ToggleSwitch } from '../components/forms';
import { IconArrowRight } from '../components/icons';
import Utils, { InputError, Validation } from '../common/utils';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	currentUser: UserDetails;
	actions: any;
	history?: any;
}
interface State {
	touched: {
		age: boolean;
	};
}
class HomePageAssessmentBottom extends React.Component<Props, State> {
	errors = { age: {} as InputError };

	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				age: false
			}
		};
	}

	componentDidMount() {
		// Only resetUser if not authenticated.
		// Otherwise, additional policies will be attached to new users and not the logged in user.
		if (!this.props.currentUser.isAuthenticated) {
			this.props.actions.resetUser();
			this.props.actions.resetCustomerDetails();
		}
		if (this.errors.age.hasError) {
			this.setState({
				touched: { ...this.state.touched, age: true }
			});
		}
	}

	onUserChange = (e: any) => {
		const user = {
			...this.props.user,
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		};

		this.props.actions.setUser(user);

		// Set user's age based on birthdate
		if (e.target.name === 'birthDate') {
			const age = Utils.getAgeRoundedFromBirthdate(e.target.value);
			const customerDetails = {
				...this.props.customerDetails,
				age: age
			};
			this.props.actions.setCustomerDetails(customerDetails);
		}
	}

	onCustomerDetailsChange = (e: any) => {
		let value = e.target.value;
		if (e.target.type === 'radio') {
			if (value === 'true') {
				value = true;
			} else if (value === 'false') {
				value = false;
			}
		} else if (e.target.type === 'checkbox') {
			value = e.target.checked;
		}

		const customerDetails = {
			...this.props.customerDetails,
			[e.target.name]: value
		};

		this.props.actions.setCustomerDetails(customerDetails);
	}

	getQuote = () => {
		const abTestIndex = Utils.getABTestOptimizeIndex();
		GoogleAnalytics.set({'exp': `Szj9gW87RKe5Yo5GErN82A.${abTestIndex}`});

		const url = Utils.getABTestWorkflowUrl(abTestIndex, this.props.customerDetails.age, this.props.user.gender);
		this.props.history.push(url);
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	validate = () => {
		// true means invalid
		return {
			age: Validation.validateAge(this.props.user.birthDate, this.props.currentUser.isAuthenticated)
		};
	}

	isGetQuoteDisabled = () => {
		// Allow user to click get quote even if inputs aren't filled. They will be redirected to the About You page.
		return this.errors.age.hasError;
	}

	render() {
		this.errors = this.validate();
		return (
			<div className="home-page-assessment home-page-assessment-bottom text-sm-center large">
				<h2 className="h3 mb-2 mb-sm-4 text-white">Get covered and get your first two months free!</h2>
				<div className="mb-3">
					<div className="form-group form-inline justify-content-sm-center">
						<div className="form-group form-inline-text form-inline-text-full">Birthdate:</div>
						<div className="form-daypicker-responsive">
							<BirthDatePicker
								// Age is set in the onChange handler based on birthdate
								className="text-dark text-left fixed-width"
								name="birthDate"
								onBlur={this.handleBlur('age')}
								onChange={this.onUserChange}
								value={this.props.user.birthDate}
								error={Utils.shouldMarkError(this.errors.age, this.state.touched.age) ? this.errors.age : undefined}
							/>
						</div>
						<div className="form-group form-inline-text form-inline-text-full">Sex at birth:</div>
						<DropdownInput
							name="gender"
							className="text-left"
							defaultOption={'Select'}
							options={[{ text: 'Male', value: 'male' }, { text: 'Female', value: 'female' }]}
							onChange={this.onUserChange}
							value={this.props.user.gender}
						/>
						<div className="form-group form-inline-text form-inline-text-full">Tobacco user:</div>
						<ToggleSwitch
							className="toggle-on-inverse text-left toggle-yes-no"
							id="isSmokerBottom"
							name="isSmoker"
							onChildren="Yes"
							offChildren="No"
							onChange={this.onCustomerDetailsChange}
							checked={this.props.customerDetails.isSmoker}
						/>
					</div>
				</div>
				<Button
					id="getQuoteBtn"
					onClick={this.getQuote}
					className="btn-primary btn-primary-inverse mt-3"
					disabled={this.isGetQuoteDisabled()}
				>
					Get my quote! <IconArrowRight />
				</Button>
			</div>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		user: state.user.user,
		customerDetails: state.quoting.customerDetails,
		currentUser: state.auth.currentUser
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...quotingActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePageAssessmentBottom));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/HomePageAssessmentBottom.tsx